import type { SiteConfig } from '/@/api/http/type'

const config: SiteConfig = {
  // license
  appId: '165950', // You need to go to the development website to apply.
  appKey: 'cdc728f92c26ccd65c220a8257d7d18', // You need to go to the development website to apply.
  appLicense: 'AFUXUfW16Z3l9WMhp84AKOb8eY3ZyvD5K1w4NNUpG7XLrZ82FxrODhggkDnWQ29FlhMb02S86suw4lZRf+uJJsylfTfn1YG106tWVZn7ZANLZKm7hUOmVniYD6RvnLvuSy03rUU4rtRpS2BZCH2uFtCRXDyg8pglJ4z9nNKCmIs=', // You need to go to the development website to apply.

  // http
  baseURL: 'http://192.168.200.55:6789/', // This url must end with "/". Example: 'http://192.168.1.1:6789/'
  websocketURL: 'ws://192.168.200.55:6789/api/v1/ws', // Example: 'ws://192.168.1.1:6789/api/v1/ws'
  dwcURL: 'http://192.168.200.55:8080', // dji wayline check background api url

  // livestreaming
  // RTMP  Note: This IP is the address of the streaming server. If you want to see livestream on web page, you need to convert the RTMP stream to WebRTC stream.
  rtmpURL: 'rtmp://192.168.200.55:1935/live/', // Example: 'rtmp://192.168.1.1/live/'
  externalRtmpBaseUrl: 'https://eagledrone.hal.se',

  // GB28181 Note:If you don't know what these parameters mean, you can go to Pilot2 and select the GB28181 page in the cloud platform. Where the parameters same as these parameters.
  gbServerIp: '',
  gbServerPort: '',
  gbServerId: '',
  gbAgentId: '',
  gbPassword: '',
  gbAgentPort: '',
  gbAgentChannel: '',
  // RTSP
  rtspUserName: 'user',
  rtspPassword: 'pass',
  rtspPort: '8554',
  // Agora
  agoraAPPID: '',
  agoraToken: '',
  agoraChannel: '',

  // map
  // You can apply on the AMap website.
  amapKey: '',
  amapUrl: 'http://192.168.200.55:9090',
  amapLatitude: '37.26204',
  amapLongitude: '128.30578',
  amapPath: '/tiles-raster/asia-cement/current',

  amapGridStartLatitude: '37.2698963',
  amapGridStartLongitude: '128.2975455',
  amapGridEndLatitude: '37.2510017',
  amapGridEndLongitude: '128.3161927',

  amapCesiumRectangleStartLongitude: 128.295,
  amapCesiumRectangleStartLatitude: 37.25,
  amapCesiumRectangleEndLongitude: 128.32,
  amapCesiumRectangleEndLatitude: 37.275,

  amapGridSize: '50',
  gmapKey: 'AIzaSyC5vnR0Z6X3_jJTk-OlXZRpfzpZiTTeYR4',

  // drone security camera livestream
  liveSeccamBaseUrl: 'http://192.168.200.55:8889',
  liveSeccamStreamPath: '/asiacemdrone-cam/whep',

  timeZone: 'Asia/Seoul'
}
export default config
